import Api from './Api';

class MovimentoCNJApi extends Api {

    async recuperarValoresComplementos(numeroMovimentoCnj) {
        let result = await this.fetch(
            this.configuracao.urlValoresComplementosMovimento + '?codEvento=' + numeroMovimentoCnj
        );
        return result.data;
    }

    async transferirMovimentos(idSessao, processos, notificarSessao = false) {
        let result;
        result = await this.fetch(
            `${
                this.configuracao.urlSessoes + idSessao
            }/transferir-movimentos?notificarSessao=${notificarSessao}`,
            'POST',
            processos
        );
        return result;
    }
}
export default MovimentoCNJApi;
